import { createSlice } from '@reduxjs/toolkit';

export type IList = {
  id: string;
  name_ru: string;
  name_uz: string;
  address: string;
  parent_id: string;
  location_type: string;
  relevance_type: string;
  total: string;
  contract: {
    id: string;
    number: string;
    start_date: string;
  };
  emails: string;
};

type IState = {
  loading: boolean;
  data: IList[];
};

const initialState: IState = {
  loading: false,
  data: [],
};

export const orgSearchListSlice = createSlice({
  name: 'orgSearchList',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      // @ts-ignore
      state.data = action.payload;
    },
  },
});

export default orgSearchListSlice.reducer;
